<script lang="ts" setup>
import { yupResolver } from '@primevue/forms/resolvers/yup'
import * as yup from 'yup'
import type { FormSubmitEvent } from '@primevue/forms'

const props = defineProps<{
  message: any
  acceptCallback: () => void
  rejectCallback: () => void
}>()

const resolver = ref(
  yupResolver(
    yup.object().shape({
      confirm: yup.boolean().required().label('Confirm'),
    })
  )
)

const onFormSubmit = ({ valid }: FormSubmitEvent) => {
  if (!valid) return

  props.acceptCallback()
}
</script>

<template>
  <Form v-slot="$form" :resolver @submit="onFormSubmit">
    <div class="p-dialog-header">
      <span class="p-dialog-title">{{ props.message.header }}</span>
    </div>

    <div class="p-dialog-content">
      <div class="flex flex-col space-y-5">
        <div>{{ props.message.message }}</div>

        <div class="flex flex-col gap-1">
          <div class="flex items-center gap-2">
            <Checkbox binary input-id="id_confirm" name="confirm" />
            <label for="id_confirm"
              >Mark this checkbox to confirm deletion</label
            >
          </div>

          <Message
            v-if="$form.confirm?.invalid"
            severity="error"
            size="small"
            variant="simple"
          >
            {{ $form.confirm.error.message }}
          </Message>
        </div>
      </div>
    </div>

    <div class="p-dialog-footer">
      <Button
        label="Cancel"
        outlined
        severity="secondary"
        type="button"
        @click="props.rejectCallback"
      />
      <Button
        :disabled="!$form.valid"
        icon="pi pi-trash"
        label="Delete"
        severity="danger"
        type="submit"
      />
    </div>
  </Form>
</template>
